import React from 'react';
import { Link } from 'react-router-dom';
import { PAGE_TITLES, SEO_CONFIG } from '../../config/seoConfig';

/**
 * RelatedPages Component - Shows related documentation pages for internal linking
 *
 * @param {Array} pages - Array of page paths (e.g., ['/docs/how-it-works', '/docs/models'])
 */
const RelatedPages = ({ pages }) => {
  if (!pages || pages.length === 0) return null;

  return (
    <div className="mt-12 pt-8 border-t border-dark-border">
      <h3 className="text-sm font-semibold text-zinc-400 uppercase tracking-wider mb-4">
        Related Pages
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {pages.slice(0, 3).map((pagePath) => {
          const title = PAGE_TITLES[pagePath] || pagePath;
          const config = SEO_CONFIG[pagePath];
          const description = config?.description?.slice(0, 80) + '...' || '';

          return (
            <Link
              key={pagePath}
              to={pagePath}
              className="group block p-4 bg-dark-tertiary border border-dark-border rounded-xl
                         hover:border-zinc-600 hover:bg-dark-surface/50 transition-colors"
            >
              <div className="font-medium text-zinc-200 group-hover:text-green-400 transition-colors mb-1">
                {title}
              </div>
              <p className="text-xs text-zinc-500 line-clamp-2">
                {description}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedPages;
